module.exports = __webpack_public_path__ + "images/icon_play_6194bf032feff7e577cbaa01fb06c74c.svg";